export default {
  top: "网格上侧的距离",
  left: "网格左侧的距离",
  right: "网格右侧的距离",
  bottom: "网格下侧的距离",
  mode: "全部内边距",
  edgeType: "边距类型" //global:全部内边距   single:独立内边距
}
